module.exports = __webpack_public_path__ + "static/fotoPerfil-d2775d7ddb880e43ef743642ae7fdb5f.jpg";